const lineHeights = {
  xxxxLarge: 1.063, // 64px
  xxxLarge: 1.182, // 44px
  xxLarge: 1.25, // 32px
  large: 1.333, // 24px
  medium: 1.333, // 18px
  base: 1.333,
  normal: 1.25, // 16px
  small: 1.43, // 14px
  xSmall: 1.333, // 12px
  xxSmall: 1.1, // 10px
} as const;

export default lineHeights;
